import React from "react";
import { Helmet } from "react-helmet";
// import FarmersSection from "./FarmersSection";
import Footer from "../../components/common/Footer";
import ProductShowcase from "../../components/common/ProductShowcase";
import ProductsSection from "../UtpannProduction/ProductsSection";
import TestimonialPage from "../PressReleaseGallery/TestimonialSection";

const ProductDetails7 = () => {
  const defensioData = {
    title: "Utpann Defensio",
    category: "Plant Immunity Booster",
    image: "/assets/Product/img7.png",
    description:
      "UTPANN Defensio is an advanced plant immunity booster that strengthens crops' natural defense mechanisms. It enhances resistance against diseases, pests, and environmental stress. Defensio supports healthier plants, stable growth, and improved yield sustainability.",
    price: "3500",
    priceNote: "Per 4kg Pack (Gujarat) (Inc GST)",
    recommendations: [
      "All Crops",
      "Plant Immunity & Resistance",
      "Stress Protect",
    ],
    specsTitle: "",
    specs: [],
    packaging: [
      { label: "Bulk", value: "1000 MT IBC" },
      { label: "Standard Pack", value: "1ltr" },
      { label: "Tanker", value: "20kl & 40kl available" },
      { label: "Minimum Order", value: "1 metric ton" },
      { label: "Custom Packaging", value: "Available on request" },
    ],
    benefits: [
      "Boosts plant immunity and natural defense systems",
      "Enhances resistance to diseases, pests, and stress conditions",
      "Supports healthier growth and faster recovery from stress",
      "Improves crop stability, yield consistency, and quality",
    ],
  };
  return (
    <>
      <Helmet>
        <title>
          Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products |
          Gujarat
        </title>
        <meta
          name="description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
        <meta
          property="og:title"
          content="Utpann Production - Organic Bio-Fertilizer & Kesari Phos Products | Gujarat"
        />
        <meta
          property="og:description"
          content="Utpann Production offers premium organic bio-fertilizers including Kesari Phos variants. 50k+ annual volume, 15+ manufacturing partners serving sustainable farming across Gujarat, India."
        />
      </Helmet>

      <main>
        <ProductShowcase productData={defensioData} />
        <div className="relative ">
          {/* Product Image Placeholder */}
          <img
            src="/assets/Product/Soil.png"
            alt={"Soil"}
            className="w-full h-auto object-contain"
          />
        </div>
        <ProductsSection />
        {/* <FarmersSection /> */}
        <TestimonialPage />
        <Footer />
      </main>
    </>
  );
};

export default ProductDetails7;
